// extracted by mini-css-extract-plugin
module.exports = {"FooterStyles":"Footer_FooterStyles__3B4ah","FooterStylesa":"Footer_FooterStylesa__3E5op"};